import React, { useState } from "react";
import { Helmet } from 'react-helmet-async';
import { Container, Row } from "react-bootstrap";
import CoreImage from "../Assets/imagecore.jpeg";
import Footer from "./footer";
import "./corevalue.css";

const principles = [
    {
        id: "01",
        title: "Integrity",
        text: `Integrity is fundamental to our ethos. We maintain the highest ethical 
        standards, ensuring that honesty, transparency, and trust are at the forefront 
        of all our interactions. We believe in making the right choices, even when no 
        one is watching, and we are dedicated to prioritizing the health and well-being 
        of our patients above all else.`
    },
    {
        id: "02",
        title: "Innovation",
        text: `Innovation is essential to our advancement and success. We are continuously 
        seeking out new technologies and refining our manufacturing processes to better 
        meet the dynamic needs of the healthcare landscape. Through rigorous research and 
        development, we aim to create therapies that genuinely enhance the lives of those 
        we serve.`
    },
    {
        id: "03",
        title: "Compassion",
        text: `Compassion motivates us to extend our mission beyond simply offering 
        medications. We are devoted to uplifting underserved communities through 
        initiatives like free health screenings and educational outreach programs. 
        Our empathetic approach ensures we address both the medical and emotional 
        needs of our patients, fostering holistic wellness.`
    },
    {
        id: "04",
        title: "Excellence",
        text: `Excellence is woven into the fabric of our quality standards. From 
        utilizing state-of-the-art manufacturing techniques to providing exceptional 
        patient care, we strive for perfection in every product and service we deliver. 
        Our commitment to excellence guarantees that every individual receives effective 
        treatments and unwavering support.`
    }
];

const CoreValue = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    const toggle = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <Container fluid className="core-page" style={{ padding: 0 }}>
            <Helmet>
                <title>Core Values | Asava Pharmaceutical Pvt Ltd</title>
                <meta name="description" content="Asava Pharmaceuticals is built on integrity, quality, and patient-first values — delivering trusted medicines to patients and pharma businesses across India." />
                <link rel="canonical" href="https://www.asavapharma.in/corevalue" />
            </Helmet>
            <div className="core-layout">

                {/* ── Left: Image ── */}
                <div className="core-image-panel">
                    <img src={CoreImage} alt="Core Values" />
                    <div className="core-image-overlay" />
                    <div className="core-image-label">
                        <p className="core-image-label-text">
                            Built on values.<br />Driven by purpose.
                        </p>
                        <div className="core-image-label-line" />
                    </div>
                </div>

                {/* ── Right: Content ── */}
                <div className="core-content-panel">
                    <div className="core-eyebrow">Our Foundation</div>
                    <h1 className="core-main-heading">
                        Core <span>Principles</span>
                    </h1>
                    <p className="core-intro">
                        At Asava Pharmaceuticals, our core principles shape our operations 
                        and guide our commitment to serving patients, partners, and the community. 
                        These values are the bedrock of our mission, influencing every decision 
                        we make.
                    </p>

                    {/* ── Accordion ── */}
                    <div className="core-principles">
                        {principles.map((item, index) => (
                            <div
                                key={item.id}
                                className={`core-principle ${activeIndex === index ? 'active' : ''}`}
                                onClick={() => toggle(index)}
                            >
                                <div className="core-principle-header">
                                    <div className="core-principle-left">
                                        <span className="core-principle-number">{item.id}</span>
                                        <span className="core-principle-title">{item.title}</span>
                                    </div>
                                    <span className="core-principle-icon">+</span>
                                </div>

                                <div className={`core-principle-body ${activeIndex === index ? 'open' : ''}`}>
                                    <div className="core-principle-divider" />
                                    <p className="core-principle-text">{item.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <Row style={{ backgroundColor: "rgb(208,208,208)" }}>
                <Footer />
            </Row>

        </Container>
    );
};

export default CoreValue;